var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFileDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M12.2785714,7.28571429 L11.1428571,7.28571429 L11.1428571,3.71428571 C11.1428571,3.32142857 10.8214286,3 10.4285714,3 L7.57142857,3 C7.17857143,3 6.85714286,3.32142857 6.85714286,3.71428571 L6.85714286,7.28571429 L5.72142857,7.28571429 C5.08571429,7.28571429 4.76428571,8.05714286 5.21428571,8.50714286 L8.49285714,11.7857143 C8.77142857,12.0642857 9.22142857,12.0642857 9.5,11.7857143 L12.7785714,8.50714286 C13.2285714,8.05714286 12.9142857,7.28571429 12.2785714,7.28571429 Z M4,14.4285714 C4,14.8214286 4.32142857,15.1428571 4.71428571,15.1428571 L13.2857143,15.1428571 C13.6785714,15.1428571 14,14.8214286 14,14.4285714 C14,14.0357143 13.6785714,13.7142857 13.2857143,13.7142857 L4.71428571,13.7142857 C4.32142857,13.7142857 4,14.0357143 4,14.4285714 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#005082",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileDownload);
export default __webpack_public_path__ + "static/media/icon_file_download.b86de375f5710247c4a560d3cb4c4ff8.svg";
export { ForwardRef as ReactComponent };